import React from 'react'
import Navbar from "../layouts/Navbar"
import FooterNew from "../layouts/FooterNew";
import styled from 'styled-components';

const About = () => {
    window.scrollTo(0,0);
    return(
        <div>
            <Navbar/>
            <AboutContent>
                    
            </AboutContent>

            <div style={{position: 'absolute', marginTop: '0.5vh'}}>
                <FooterNew fullength={true}/>
            </div>
        </div>
    )
}
const AboutContent = styled.div`
    box-sizing:border-box;
    width: 100vw;
    height:78.9vh;
`
export default About;